import { createAction } from '@reduxjs/toolkit'
import { BattleData } from './reducer'

export const updateBattles = createAction<{ data: BattleData }>('battle/updateBattles')
